import React from 'react';

const DescriptionRow = props => {
    const {_key, value} = props;
    let displayValue = (Array.isArray(value) ? value.join(", ") : value);
    return (
        <div className="outerDiv">
            <div className="rightDiv">
                {_key + ":"}
            </div>

            <div className="leftDiv">
                {displayValue}
            </div>
        </div>);
}


class ProductDetails extends React.Component {

    constructor(props) {
        super(props);
        this.props = props;
        this.state = {
            view: 'comment'
        }
    }

    changeView = (view) => {
        this.setState({
            view
        })
    }

    render() {
        const {details, orientation, photos, size, shortDescription} = this.props;
        const {view} = this.state;
        // const shortDescription = "<ul className='abcs'><li>Easy to create</li><li>Choose from a variety of occasions, backgrounds and layouts</li><li>Upload pictures and add text</li><li>Your choice of landscape or portrait orientations</li><li>Archival-quality paper</li></ul>";
        return (
            <div style={{
                marginTop: "8px"
            }}>
                <div className="description-details" id="short-description">
                    <div dangerouslySetInnerHTML={{__html: shortDescription}}>

                    </div>

                </div>
                <ul>
                    {
                        details && details.map((detail, index) => {
                            return (<li key={index}>{detail}</li>)
                        })
                    }
                </ul>
                {
                    orientation &&
                    <DescriptionRow
                        key={1}
                        _key="Orientation"
                        value={orientation}/>
                }

                {
                    photos &&
                    <DescriptionRow
                        key={2}
                        _key="Photos"
                        value={photos}/>
                }

                {
                    size && size.length >= 1 &&
                    <DescriptionRow
                        key={3}
                        _key="Size"
                        value={size}/>
                }
            </div>)
    }
}

export default ProductDetails;